import { ImageBackground, View } from "react-native";
import React from "react";
import { AccountTicketDetails, TenantOptionsDetails } from "features/types";
import { Image } from "expo-image";
import { FANRALLY_LOGO_MASTER } from "constants/";
import { Text } from "@ui-kitten/components";
import { svgURL } from "utils/fileUtils";
import { formatEventDate } from "utils/eventUtils";
import { formatCurrency } from "utils/appUtils";

interface Props {
  ticket: AccountTicketDetails;
  tenantConfig: TenantOptionsDetails;
}

const ActivityDetails = (props: Props) => {
  const {
    ticket: {
      event: { name, venueName, venueCity, venueState, hostName },
    },
    tenantConfig,
  } = props;

  const tenantLogo = svgURL(hostName, false);

  const subtotal = props.ticket.tickets.reduce((subtotal, ticket) => {
    return Number(ticket.charge?.totalPrice || 0) + subtotal;
  }, 0);

  const credits = props.ticket.tickets.reduce((subtotal, ticket) => {
    return Number(ticket.charge?.totalCredits || 0) + subtotal;
  }, 0);

  const points = props.ticket.tickets.reduce((subtotal, ticket) => {
    return Number(ticket.charge?.totalPoints || 0) + subtotal;
  }, 0);

  const total = props.ticket.tickets.reduce((subtotal, ticket) => {
    return Number(ticket.charge?.totalCreditCardCharges || 0) + subtotal;
  }, 0);

  const generateContact = () => {
    const supportEmail = tenantConfig.supportEmail;
    const supportPhone = tenantConfig.supportPhone;
    return (
      <Text>
        If you have any questions, contact us at{" "}
        <Text category="s1">{supportEmail ? supportEmail : ""}</Text>
        {supportEmail && supportPhone ? " or call us at " : ""}
        {supportPhone ? <Text category="s1">{supportPhone}</Text> : ""}.
      </Text>
    );
  };

  return (
    <div id="activity-details">
      <ImageBackground
        source={{ uri: tenantLogo }}
        imageStyle={{ opacity: 0.1 }}
        style={{ flex: 1, padding: 15 }}
      >
        <Image
          source={{ uri: FANRALLY_LOGO_MASTER }}
          style={{ height: 50, width: 175 }}
          contentFit="contain"
        />

        <View className="mt-4">
          <Text category="h6">{name}</Text>
          <Text>
            {formatEventDate(props.ticket.event, "ddd • MMM DD • hh:mm A")}
          </Text>
          <Text>
            {venueName} - {venueCity}, {venueState}
          </Text>
        </View>

        <View className="mt-4 space-y-2">
          <Text category="h6">Payment Details</Text>
          <View className="flex flex-row justify-between">
            <Text>Subtotal</Text>
            <Text>{formatCurrency(subtotal)}</Text>
          </View>
          <View className="flex flex-row justify-between">
            <Text status="success">Points</Text>
            <Text status="success">{formatCurrency(points)}</Text>
          </View>
          <View className="flex flex-row justify-between">
            <Text status="success">Credits</Text>
            <Text status="success">{formatCurrency(credits)}</Text>
          </View>
          <View className="flex flex-row justify-between">
            <Text>Total</Text>
            <Text>{formatCurrency(total)}</Text>
          </View>
        </View>

        <View className="mt-4">
          <Text>{generateContact()}</Text>
        </View>
      </ImageBackground>
    </div>
  );
};

export default ActivityDetails;
